"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuScrollingArea = void 0;
const typestyle_1 = require("typestyle");
const Colors_1 = require("../../../../Colors");
const react_1 = __importDefault(require("react"));
const Main = typestyle_1.style({
    color: Colors_1.Colors.grey[0],
    maxHeight: 200,
    overflowY: 'auto',
    scrollbarColor: `${Colors_1.Colors.grey[8]} ${Colors_1.Colors.grey[10]}`,
    scrollSnapType: 'y mandatory',
});
exports.MenuScrollingArea = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (react_1.default.createElement("div", Object.assign({ className: Main }, props), children));
};
